import Scrollspy from './Scrollspy';

export default Scrollspy;
